export const DEFAULT_TEMPERATURE = 0.1;
export const DEFAULT_MAX_TOKENS = 4000;
